import React from 'react';
import { Container } from '../ui/Primitives';
import { Photo } from '../ui/Photo';
import type { SitePhoto } from '../../data/photos';
interface PhotoStripProps {
  title: string;
  intro?: string;
  /** One lead photo and two supporting photos. */
  photos: [SitePhoto, SitePhoto, SitePhoto];
  id: string;
}

/** One large photograph with two smaller ones beside it. */
export function PhotoStrip({
  title,
  intro,
  photos,
  id
}: PhotoStripProps) {
  const [lead, second, third] = photos;
  return <section aria-labelledby={id} data-id="element-1263" data-mp="5x2re5xqnot">
      <Container className="py-16 sm:py-20" data-id="element-1264" data-mp="43qnjcjzb9f">
        <div className="max-w-2xl" data-id="element-1265" data-mp="3ib0a75jdjbse">
          <h2 id={id} className="font-display text-[26px] leading-tight text-ink sm:text-[32px]" data-id="element-1266" data-mp="3i9yo860tl4vw">
            {title}
          </h2>
          {intro && <p className="mt-4 text-[16px] text-body" data-id="element-1267" data-mp="3nc7g0z1yi0wf">{intro}</p>}
        </div>
        <div className="mt-10 grid gap-6 lg:grid-cols-[1.5fr_1fr]" data-id="element-1268" data-mp="26ua1nfrha7vm">
          <Photo photo={lead} aspect="aspect-[16/10]" data-id="element-1269" data-mp="2bv7q2a32zy5k" />
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-1" data-id="element-1270" data-mp="2bslabn61ecc9">
            <Photo photo={second} aspect="aspect-[16/10] lg:aspect-[16/9]" data-id="element-1271" data-mp="2ovk5kueq68wx" />
            <Photo photo={third} aspect="aspect-[16/10] lg:aspect-[16/9]" data-id="element-1272" data-mp="2jx0kew7yh15m" />
          </div>
        </div>
      </Container>
    </section>;
}